import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";
import { getBrandCustom } from "../../../../../../util/getCustomColor";

type Props = {
  active: boolean;
  rightButton?: boolean;
};

const Root = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  marginBottom: 24,
}));

const Button = styled("div")(({ active, rightButton }: Props) => ({
  cursor: "pointer",
  padding: "10px 12px",
  borderRight: rightButton ? `1px solid ${colors.gray300}` : 0,
  borderTop: `1px solid ${colors.gray300}`,
  borderLeft: `1px solid ${colors.gray300}`,
  borderBottom: `1px solid ${colors.gray300}`,
  width: 104,
  height: 40,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: rightButton ? "0 8px 8px 0" : "8px 0 0 8px",
  backgroundColor: active
    ? getBrandCustom("headerBackgroundColor", colors.brandBlue50)
    : colors.white,
}));

const Text = styled("div")(({ active }: Props) => ({
  textAlign: "center",

  fontSize: "14px",
  fontWeight: 600,
  fontStyle: "normal",
  lineHeight: "20px",
  letterSpacing: "0.1px",
  fontFamily: "Manrope",
  color: active ? getBrandCustom("primaryColor", colors.brandBlue500) : colors.gray800,
  userSelect: "none",
}));

export const Header = { Root, Button, Text };
